import React, { useEffect, useRef, useState } from "react";
import Icon from "components/Icon";
import axios from "axios";
import "./index.css";
import env from "config";
import { useUsersContext } from "context/usersContext";
import IntegrationModal from "./IntegrationModal";
import MicrosoftModal from "./IntegrationModal/Microsoftmodal";
import slackIcon from "../../assets/images/Slack.png";
import microsoftteamIcon from "../../assets/images/MicrosoftTeams.png";
import Select from "react-select";
import DeleteChatModal from "components/DeleteChatModal";
import { useHistory } from "react-router-dom";
import AnimatedText from "components/Animation/AnimatedText";
import LoadingDots from "components/Animation/LoadingDots";


const formatToTimeInput = (isoString) => {
  const date = new Date(isoString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

const BASE_URL = `${env.API_URL}/v1`;

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content text-center"
            onClick={(e) => e.stopPropagation()}
            style={{ border: "none" }}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
// Example usage in another component
const PromptModal = ({
  isModalOpen,
  justCloseIt,
  categories,
  subCategories: initialSubCategories,
  getUpdatePromptsData,
  editadata,
  setIsEditPrompt,
  utcOffset,
  autoloadfirsttext,
  assistantData,
  asistantSelected,
}) => {
  const { SSO, showToast } = useUsersContext();
  const history = useHistory();

  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showAddSubCategoryModal, setShowAddSubCategoryModal] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [subCategories, setSubCategories] = useState(initialSubCategories);
  const [askToDeleteModal, setAskToDeleteModal] = useState(false);

  // prompt payload states
  const [promptName, setPromptName] = useState(editadata?.title);
  const [promptCategory, setPromptCategory] = useState(editadata?.category);
  const [promptSubCategory, setPromptSubCategory] = useState();
  const [promptContent, setPromptContent] = useState(editadata?.prompt_value);
  const [promptSetAs, setPromptSetAs] = useState(editadata?.set_as);
  const [outputOption, setOutputOption] = useState(editadata?.output || { value: "chatUi", label: "Chat UI", name: "chatui" });
  const [slackChannel, setSlackChannel] = useState(editadata?.channel || "");
  const [openIntegrationModal, setOpenIntegrationModal] = useState(false);
  const [loadingIntegrations, setLoadingIntegrations] = useState(false);
  const [requiredIntegrations, setRequiredIntegrations] = useState([]);
  const [integrationId, setIntegrationId] = useState(editadata?.integration_id || null);
  const [utcTime, setUtcTime] = useState(editadata?.utcTime || null)
  const [selectedWeekDays, setSelectedWeekDays] = useState(editadata?.selectedWeekDays || []);
  const [scheduleDate, setScheduleDate] = useState(editadata?.scheduleDate || "");

  const [channelList, setChannelList] = useState([]);
  const [selectedChannelOption, setSelectedChannelOption] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingMoreChannels, setLoadingMoreChannels] = useState(false);
  const [hasMoreChannels, setHasMoreChannels] = useState(false);
  const [nextChannelPageToken, setNextChannelPageToken] = useState(null);
  const [channelSearchQuery, setChannelSearchQuery] = useState("");
  const [activeChannelProvider, setActiveChannelProvider] = useState(null);
  const [activeChannelIntegration, setActiveChannelIntegration] = useState(null);
  const channelSearchTimer = useRef(null);

  // error status
  const [promptNameError, setPromptNameError] = useState(null);
  const [promptCategoryError, setPromptCategoryError] = useState(null);
  const [promptContentError, setPromptContentError] = useState(null);

  const [showAddNewPrompt, setShowAddNewPrompt] = useState(false);

  // Add Mode States
  const [promptstep, setpromptstep] = useState(0);
  const [promptQuery, setPromptQuery] = useState(autoloadfirsttext || "");
  const [promptQueryError, setPromptQueryError] = useState("");

  const isEdit = !!editadata;

  useEffect(() => {
    if (!isEdit && autoloadfirsttext) {
      setPromptQuery(autoloadfirsttext);
    }
    if (!isEdit) {
      setpromptstep(0);
    }
  }, [autoloadfirsttext, isModalOpen, isEdit]);

  const [rqIntegration, setRqIntegration] = useState(null);
  const [scheduleFrequency, setScheduleFrequency] = useState(
    editadata?.repeat || "none"
  );
  const [scheduleTime, setScheduleTime] = useState(
    editadata?.scheduleTime ? formatToTimeInput(editadata.scheduleTime) : ""
  );

  const [isScheduleActive, setIsScheduleActive] = useState(
    editadata?.active || false
  );

  const handleScheduleFrequencyChange = (frequency) => {
    setScheduleFrequency(frequency);
    if (frequency !== "none") {
      setIsScheduleActive(true);
    } else {
      setIsScheduleActive(false);
    }
  };

  const handleSchedulePause = () => {
    setIsScheduleActive(!isScheduleActive);
  };

  const handleScheduleDelete = () => {
    setScheduleFrequency("none");
    setScheduleTime("");
    setIsScheduleActive(false);
  };

  const handleDeleteClick = async () => {
    const response = await axios.delete(`${BASE_URL}/chat/promptDelete?_id=${editadata._id}`);
    if (response) {
      const redirectUrl = `/`;
      history.push(redirectUrl);
      justCloseIt();
      getUpdatePromptsData();
      setAskToDeleteModal(false);
    } else {
      showToast('Something went wrong!')
    }
  };

  const handleDeleteScheduledPrompt = async () => {
    const response = await axios.delete(`${BASE_URL}/prompts/delete/scheduled?_id=${editadata._id}`);
    if (response) {
      const redirectUrl = `/`;
      history.push(redirectUrl);
      justCloseIt();
      getUpdatePromptsData();
      setAskToDeleteModal(false);
    } else {
      showToast('Something went wrong!')
    }
  };

  const resetPromptForm = () => {
    setPromptName("");
    setPromptCategory("");
    setPromptSubCategory("");
    setPromptContent("");
    setPromptSetAs("personal");
  };

  const handleClose = () => {
    justCloseIt();
  };

  const handleCloseModal = () => {
    setShowAddCategoryModal(false);
    setShowAddSubCategoryModal(false);
    getUpdatePromptsData();
  };

  const handleAddCategory = () => {
    setShowAddCategoryModal(true);
  };

  const handleAddSubCategory = () => {
    setShowAddSubCategoryModal(true);
  };

  const handlePromptSubmit = async () => {
    if (processing) return;
    setProcessing(true);

    // Reset all previous errors
    setPromptNameError(null);
    setPromptCategoryError(null);
    setPromptContentError(null);

    let hasError = false;

    // Validate the required fields
    if (!promptName) {
      setPromptNameError("Prompt Name is required");
      hasError = true;
    }

    if (!promptContent) {
      setPromptContentError("Prompt Content is required");
      hasError = true;
    }

    if (hasError) {
      setProcessing(false);
      return;
    }

    let response;


    const payload = {
      title: promptName,
      category: promptCategory,
      sub_category: promptSubCategory,
      prompt_value: promptContent,
      type: "user",
      userId: {
        id: SSO?.UserInfo?.userId,
        type: "author",
        username: SSO?.chat_username,
      },
      locationId: SSO?.id,
      set_as: promptSetAs,
      output: outputOption?.value,
      channel: slackChannel,
      utcTime
    };

    if (isEdit) {
      payload._id = editadata._id;
    } else {
      payload.assistant_name = asistantSelected?.assistant_name;
      payload.assistant_id = asistantSelected?.assistant_id;
    }

    {
      payload.scheduleTime = scheduleTime;
      payload.repeat = scheduleFrequency;
      payload.active = isScheduleActive;
      // Add extra scheduling fields for weekly, monthly, yearly
      if (scheduleFrequency === "weekly" || scheduleFrequency === "weekdays" || scheduleFrequency === "weekends") {
        payload.weekDays = selectedWeekDays;
      }
      if (scheduleFrequency === "monthly" || scheduleFrequency === "yearly") {
        payload.scheduleDate = scheduleDate;
      }
    }
    if (payload.repeat === "none") {
      payload.utcTime = null;
    }
    else {
      payload.utcTime = utcTime;
    }

    if (integrationId) payload.integration_id = integrationId;

    if (isEdit) {
      response = await axios.put(`${BASE_URL}/prompts/update/scheduled`, payload);
    } else {
      response = await axios.post(`${BASE_URL}/prompts`, payload);
    }

    setProcessing(false);
    if (response) {
      handleClose();
      getUpdatePromptsData();
      resetPromptForm();
      if (isEdit) setIsEditPrompt();
    }
  };

  const handlestep1 = () => {
    if (promptQuery === "") {
      setPromptQueryError(true);
      return false;
    }
    setPromptQueryError(false);
    GeneratePrompt();
  };

  const GeneratePrompt = async () => {
    setpromptstep(1);
    const customTaskAssistant = await axios.get(
      `${BASE_URL}/assistant/custom-task-agent?agency_id=${SSO?.agency_id}&assistant_type=Custom Task`
    );
    if (customTaskAssistant) {
      await axios
        .post(BASE_URL + "/prompts/generate", {
          locationId: SSO?.id,
          username: SSO?.chat_username,
          promptQuery: promptQuery,
          assistant_id: customTaskAssistant
            ? customTaskAssistant?.data?.data?.assistant_id
            : asistantSelected?.assistant_id,
          user_id: SSO?.UserInfo?.userId,
        })
        .then(async function (response) {
          setpromptstep(2);
          setPromptName(response.data?.data?.title);
          setPromptContent(response.data?.data?.content);
        })
        .catch(function (error) {
          setpromptstep(5);
          return error;
        });
    }
  };

  const detectEnterPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      handlestep1();
    }
  };
  useEffect(() => {
    handleCategoryChange(promptCategory);
  }, [initialSubCategories]);
  const handleCategoryChange = (selectedCategoryId) => {
    const filteredSubCategories = initialSubCategories?.filter(
      (subCategory) => subCategory.category_id === selectedCategoryId
    );

    // Set the filtered subcategories and reset the selected subcategory
    setSubCategories(filteredSubCategories);
    if (filteredSubCategories?.length > 0) {
      setPromptSubCategory(filteredSubCategories[0]._id);
    } else {
      setPromptSubCategory("");
    }
  };

  useEffect(() => {
    setShowAddNewPrompt(false);
  }, [isModalOpen]);

  useEffect(() => {
    return () => {
      if (channelSearchTimer.current) {
        clearTimeout(channelSearchTimer.current);
      }
    };
  }, []);

  const mergeChannels = (existingChannels = [], newChannels = []) => {
    const seen = new Set(existingChannels.map((channel) => channel?.channel_id));
    const merged = [...existingChannels];

    newChannels.forEach((channel) => {
      const channelId = channel?.channel_id;
      if (!channelId || seen.has(channelId)) return;
      seen.add(channelId);
      merged.push(channel);
    });

    return merged;
  };

  const parseChannelsPayload = (payload) => {
    const normalized = payload?.data_type
      ? payload
      : payload?.data?.data_type
        ? payload?.data
        : payload;

    const channels = Array.isArray(normalized?.data)
      ? normalized.data
      : Array.isArray(normalized)
        ? normalized
        : [];

    const pagination = normalized?.pagination || {};

    return { channels, pagination };
  };

  const handleOutputOptionChange = (option) => {
    setOutputOption(option);
    const providerId = option?.value?.toLowerCase();
    if (channelSearchTimer.current) {
      clearTimeout(channelSearchTimer.current);
    }

    if (providerId !== "slack" && providerId !== "microsoft-teams") {
      setActiveChannelProvider(null);
      setActiveChannelIntegration(null);
      setChannelSearchQuery("");
      setHasMoreChannels(false);
      setNextChannelPageToken(null);
      setChannelList([]);
      setSlackChannel("");
      setSelectedChannelOption(null);
      return;
    }

    setChannelSearchQuery("");
    setHasMoreChannels(false);
    setNextChannelPageToken(null);
    setChannelList([]);
    setSlackChannel("");
    setSelectedChannelOption(null);

    if (providerId === 'slack' || providerId === 'microsoft-teams') {
      const findInt = requiredIntegrations.find((p) => (p.provider_id || "").toLowerCase() === providerId);
      if (findInt) {
        if (findInt.integration_id) setIntegrationId(findInt.integration_id);
        if (!findInt.connected) {
          setRqIntegration(providerId);
          setOpenIntegrationModal(true);
        } else {
          // provider connected -> ensure modal closed and proceed, include integration_id
          console.log(findInt, "findInt");

          setOpenIntegrationModal(false);
          launchChat(option, findInt?.integration_id, {
            search: "",
            pageToken: "",
            append: false,
          });
        }
      } else {
        // no provider found -> proceed with launch (no integration id available)
        launchChat(option, null, {
          search: "",
          pageToken: "",
          append: false,
        });
      }
    }
  };

  const handleSlackChannelChange = (selectedOption) => {
    const channel = selectedOption?.value || "";
    console.log("channel changed:", channel);

    setSlackChannel(channel);
    setSelectedChannelOption(selectedOption || null);
    // log selected channel id and matching channel object
    try {
      const match = channelList.find((c) => c.channel_id === channel);
      console.log("slack channel selected:", channel, "object:", match || null);
    } catch (e) {
      console.log("slack channel selected:", channel);
    }
  };

  useEffect(() => {
    if (!slackChannel) {
      setSelectedChannelOption(null);
      return;
    }

    const match = channelList.find((channel) => channel.channel_id === slackChannel);
    if (match) {
      setSelectedChannelOption({
        value: match.channel_id,
        label: match.channel_name,
      });
    }
  }, [slackChannel, channelList]);

  const handleChannelSearchInputChange = (inputValue, actionMeta) => {
    if (actionMeta?.action !== "input-change") return inputValue;

    const searchValue = inputValue || "";
    setChannelSearchQuery(searchValue);

    if (channelSearchTimer.current) {
      clearTimeout(channelSearchTimer.current);
    }

    if (!activeChannelProvider) return inputValue;

    channelSearchTimer.current = setTimeout(() => {
      launchChat(
        { value: activeChannelProvider },
        activeChannelIntegration,
        {
          search: searchValue,
          pageToken: "",
          append: false,
        }
      );
    }, 350);

    return inputValue;
  };

  const handleChannelMenuScrollToBottom = () => {
    if (!activeChannelProvider) return;
    if (!hasMoreChannels || !nextChannelPageToken) return;
    if (loading || loadingMoreChannels) return;

    launchChat(
      { value: activeChannelProvider },
      activeChannelIntegration,
      {
        search: channelSearchQuery,
        pageToken: nextChannelPageToken,
        append: true,
      }
    );
  };

  const fetchProviders = async (arg = null) => {
    try {
      const response = await axios.get(`${BASE_URL}/prompts/providers`, {
        params: {
          profile_id: SSO?.id,
          user_id: SSO?.UserInfo?.userId,
          agency_id: SSO?.agency_id,
        },
        timeout: 10000,
      });

      // normalize provider array from various possible shapes
      const payload = response?.data?.data?.data || {};

      const providersArr = Array.isArray(payload)
        ? payload
        : Array.isArray(payload.data)
          ? payload.data
          : Array.isArray(payload.data?.data)
            ? payload.data.data
            : [];

      setRequiredIntegrations(providersArr || []);

      // find provider based on editadata output
      const targetProviderId = editadata?.output || arg;
      const targetProvider = (providersArr || []).find((p) => {
        const id = (p.provider_id || p.provider || p.provider_name || p.name || "").toString().toLowerCase();
        return id === targetProviderId;
      });

      if (['slack', 'microsoft-teams'].includes(targetProviderId)) {
        setOutputOption({
          value: targetProviderId,
          label: (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <img
                src={targetProviderId === 'slack' ? slackIcon : microsoftteamIcon}
                alt={targetProvider?.provider_name || targetProviderId}
                style={{ width: 16, height: 16 }}
              />
              <span>{targetProvider?.provider_name || targetProviderId}</span>
            </div>
          ),
          name: targetProvider?.provider_name || targetProviderId
        });

        if (targetProvider) {
          if (targetProvider.integration_id) {
            setIntegrationId(targetProvider.integration_id);
          }
          if (!targetProvider.connected) {
            setOpenIntegrationModal(true);
            setRqIntegration(targetProviderId);
          } else {
            setOpenIntegrationModal(false);
            launchChat({
              value: targetProviderId,
              label: (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <img
                    src={targetProviderId === 'slack' ? slackIcon : microsoftteamIcon}
                    alt={targetProvider.provider_name}
                    style={{ width: 16, height: 16 }}
                  />
                  <span>{targetProvider.provider_name}</span>
                </div>
              )
            }, targetProvider.integration_id, {
              search: "",
              pageToken: "",
              append: false,
            });
          }
        }
      } else {
        setOutputOption(editadata?.output);
      }

    } catch (err) {
      console.error("Error fetching providers:", err);
    }
  };

  useEffect(() => {
    fetchProviders();
  }, [SSO, editadata]);

  const launchChat = async (option, integration, fetchOptions = {}) => {
    const { search = "", pageToken = "", append = false } = fetchOptions;
    if (option?.value !== "chatUi") {
      try {
        if (append) {
          setLoadingMoreChannels(true);
        } else {
          setLoading(true);
        }

        setActiveChannelProvider(option?.value || null);
        setActiveChannelIntegration(integration || null);
        if (!append) {
          setChannelSearchQuery(search || "");
        }

        if (['slack', 'microsoft-teams'].includes(option?.value)) {
          const response = await axios.get(`${BASE_URL}/prompts/providers/channels`, {
            params: {
              profile_id: SSO?.id,
              user_id: SSO?.UserInfo?.userId,
              channel_type: "bot",
              include_private: true,
              ...(integration ? { integration_id: integration } : {}),
              integration: option?.value,
              ...(search ? { search } : {}),
              ...(pageToken ? { page_token: pageToken } : {}),
            },
            timeout: 600000,
          });
          const providerPayload = response?.data?.data || {};
          const { channels, pagination } = parseChannelsPayload(providerPayload);
          const arrayChannels = Array.isArray(channels) ? channels : [];

          setChannelList((prev) =>
            append ? mergeChannels(prev, arrayChannels) : arrayChannels
          );

          const nextPageToken = pagination?.next_page_token || null;
          setNextChannelPageToken(nextPageToken);
          setHasMoreChannels(Boolean(pagination?.has_next && nextPageToken));

          if (!append) {
            setSlackChannel((prev) => {
              if (prev && prev !== "") return prev;
              if (
                editadata?.channel &&
                arrayChannels.some((channel) => channel.channel_id === editadata?.channel)
              ) {
                return editadata.channel;
              }
              const first = arrayChannels.length > 0 ? arrayChannels[0]?.channel_id : "";
              return first || "";
            });
          }
        }
      } catch (err) {
        console.error("Error fetching providers:", err);
      } finally {
        setLoading(false);
        setLoadingMoreChannels(false);
      }
    }
  };

  const handleScheduleTimeChange = (time) => {
    setScheduleTime(time);
    function convertLocalToUTC(localTimeHHMM, offset) {
      const [h, m] = localTimeHHMM.split(":").map(Number);

      const match = offset.match(/([+-])(\d{2}):(\d{2})/);
      const sign = match[1];
      const offH = Number(match[2]);
      const offM = Number(match[3]);

      const localMinutes = h * 60 + m;
      const offsetMinutes = (offH * 60 + offM) * (sign === "+" ? 1 : -1);

      let utcMinutes = localMinutes - offsetMinutes;
      utcMinutes = (utcMinutes + 1440) % 1440;

      const hh = String(Math.floor(utcMinutes / 60)).padStart(2, "0");
      const mm = String(utcMinutes % 60).padStart(2, "0");

      return `${hh}:${mm}`;
    }
    setUtcTime(convertLocalToUTC(time, utcOffset))
  }

  return (
    <div>
      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content">
          {showAddCategoryModal && (
            <AddCategoryModal onClose={handleCloseModal} />
          )}
          {showAddSubCategoryModal && (
            <AddSubCategoryModal
              onClose={handleCloseModal}
              categories={categories}
            />
          )}

          {!showAddCategoryModal && !showAddSubCategoryModal ? (
            <div style={{ position: "relative" }}>
              {(isEdit || promptstep !== 1) ? (
                <>
                  <p
                    style={{
                      position: "absolute",
                      right: 0,
                      width: "12px",
                      height: "12px",
                      cursor: "pointer",
                    }}
                    onClick={handleClose}
                  >
                    <Icon id="close" />
                  </p>
                </>
              ) : (
                ""
              )}

              {/* Add Mode Steps */}
              {!isEdit && promptstep === 0 && (
                <div className="formGroup">
                  <p className="modalText">Add a task</p>
                  <p className="roundofaddprompt z-w-60">
                    <Icon id={"magicstar"} />{" "}
                    <AnimatedText text="What do you want to do?" speed={50} />
                  </p>
                  <div style={{ position: "relative" }}>
                    <textarea
                      value={promptQuery}
                      required
                      placeholder="Start Typing ..."
                      name="promptQuery"
                      onChange={(e) => setPromptQuery(e.target.value)}
                      onKeyDown={(e) => detectEnterPress(e)}
                      className="input_od_addPrompt"
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        overflowY: "auto",
                        maxHeight: "50px",
                        overflowX: "hidden",
                        resize: "none",
                      }}
                      rows={1}
                      onInput={(e) => {
                        e.target.style.height = "auto";
                        e.target.style.height = `${e.target.scrollHeight}px`;
                      }}
                    />
                    <button
                      onClick={handlestep1}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "15px",
                      }}
                    >
                      <Icon id="sendChat" className="chat__input-icon" />
                    </button>
                  </div>
                  {promptQueryError && (
                    <small style={{ color: "red" }}>
                      Should not be empty
                    </small>
                  )}
                </div>
              )}

              {!isEdit && promptstep === 1 && (
                <div className="formGroup">
                  <p
                    className="roundofaddprompt z-w-100 text-center"
                    style={{ marginBottom: 0 }}
                  >
                    <Icon id={"magicstar"} /> Creating task
                    <LoadingDots speed={100} />
                  </p>
                </div>
              )}

              {!isEdit && promptstep === 5 && (
                <div className="formGroup">
                  <p
                    className="roundofaddprompt z-w-100 text-center"
                    style={{ marginBottom: 0, background: "#ffdddd" }}
                  >
                    <Icon id={"magicstar"} /> Something Went Wrong!{" "}
                  </p>
                </div>
              )}


              {/* Form (Edit or Step 2 of Add) */}
              {(isEdit || promptstep === 2) && (
                <>
                  <p className="modalText flex justify-center align-center w-full">{isEdit ? "Edit a task" : "Add a task"}</p>
                  {!isEdit && (
                    <p className=" z-w-100 " style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                      Here’s your task, please check and edit it below.
                    </p>
                  )}
                  <div className="formGroup" style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "10px" }}>
                    <label>Name</label>
                    <input
                      type="text"
                      name="promptName"
                      placeholder="Prompt Name"
                      className="flex-1 modalInputs"
                      value={promptName}
                      onChange={(e) => {
                        setPromptName(e.target.value);
                        setPromptNameError(null);
                      }}
                    />
                    {promptNameError && (
                      <small style={{ color: "red" }}>{promptNameError}</small>
                    )}
                    <div >
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <label htmlFor="status-toggle" style={{ marginRight: "8px" }}>Status</label>
                        <span style={{ display: "inline-block", position: "relative", width: "40px", height: "20px" }}>
                          <input
                            id="status-toggle"
                            type="checkbox"
                            checked={isScheduleActive}
                            onChange={handleSchedulePause}
                            style={{
                              opacity: 0,
                              width: "40px",
                              height: "20px",
                              position: "absolute",
                              left: 0,
                              top: 0,
                              margin: 0,
                              cursor: "pointer"
                            }}
                          />
                          <span
                            style={{
                              display: "block",
                              width: "40px",
                              height: "20px",
                              background: isScheduleActive ? "#4caf50" : "#C00F0C",
                              borderRadius: "20px",
                              transition: "background 0.2s"
                            }}
                          ></span>
                          <span
                            style={{
                              position: "absolute",
                              left: isScheduleActive ? "22px" : "2px",
                              top: "2px",
                              width: "16px",
                              height: "16px",
                              background: "#fff",
                              borderRadius: "50%",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                              transition: "left 0.2s"
                            }}
                          ></span>
                        </span>
                      </div>
                      <p>{isScheduleActive ? "Live" : "Paused"}</p>
                    </div>
                  </div>

                  <div className="formGroup" style={{ marginBottom: "20px" }}>
                    <label>Select output channel</label>
                    <Select
                      height={36}
                      placeholder="Please select an output channel"
                      value={
                        outputOption?.value === "slack" || outputOption?.value === "microsoft-teams"
                          ? outputOption
                          : { value: "chatUi", label: "Chats", name: "chatui" }

                      }
                      onChange={(opt) => handleOutputOptionChange(opt)}
                      options={[
                        ...(requiredIntegrations?.length > 0 ? [...requiredIntegrations]
                          .sort((a, b) => (a.provider_name || "").localeCompare(b.provider_name || ""))
                          .map((option) => ({
                            value: option.provider_id, label: ['slack', 'microsoft-teams'].includes(option.provider_id) ? (
                              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <img
                                  src={option.provider_id === 'slack' ? slackIcon : microsoftteamIcon}
                                  alt={option.provider_name}
                                  style={{ width: 16, height: 16 }}
                                />
                                <span>{option?.provider_name}</span>
                              </div>
                            ) : option.provider_name,
                            name: option.provider_name
                          })) : []),
                        { value: "chatUi", label: "Chats", name: "chatui" },
                      ]}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: 40,
                          height: 40,
                          borderColor: "#ccc",
                          boxShadow: "none",
                          fontSize: 14,
                        }),
                        valueContainer: (base) => ({ ...base, padding: "0 8px", height: 40, marginTop: -14 }),
                        indicatorsContainer: (base) => ({ ...base, height: 40 }),
                        input: (base) => ({ ...base, margin: 0, padding: 0 }),
                        menu: (base) => ({ ...base, zIndex: 10 }),
                      }}
                      isSearchable={false}
                    />
                  </div>

                  {['slack', 'microsoft-teams'].includes(outputOption?.value) && (
                    <div className="formGroup" >
                      <label>{outputOption?.value === 'slack' ? 'Slack' : 'Teams'} Channel <span style={{ color: "#8c8c8c", fontSize: "11px" }}>{`Please add @${outputOption?.name?.toLocaleLowerCase()?.includes('mida') ? 'MIDAS Slack' : (outputOption?.name?.toLocaleLowerCase()?.includes('spud') ? "SPUD" : outputOption?.value === 'microsoft-teams' && (SSO?.agency_id?.includes('6739f1be347a7f5974735cec') || SSO?.agency_id?.includes('68f22c8ddcb06046ab258bc2')) ? 'Maybe' : 'the Bot')} to the channels you want tasks to be delivered in.`}</span></label>
                      <Select
                        placeholder="Search and select a channel"
                        value={selectedChannelOption}
                        onChange={handleSlackChannelChange}
                        options={channelList.map((channel) => ({
                          value: channel.channel_id,
                          label: channel.channel_name,
                        }))}
                        onInputChange={handleChannelSearchInputChange}
                        onMenuScrollToBottom={handleChannelMenuScrollToBottom}
                        isLoading={loading || loadingMoreChannels}
                        filterOption={null}
                        noOptionsMessage={() =>
                          loading
                            ? "Loading channels..."
                            : channelSearchQuery
                              ? "No channels found"
                              : "No channels available"
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: 40,
                            borderColor: "#ccc",
                            boxShadow: "none",
                            fontSize: 14,
                          }),
                          menu: (base) => ({ ...base, zIndex: 10 }),
                        }}
                      />
                      {hasMoreChannels && !loadingMoreChannels && (
                        <small style={{ color: "#8c8c8c" }}>
                          Scroll to load more channels
                        </small>
                      )}
                      {loadingMoreChannels && (
                        <small style={{ color: "#8c8c8c" }}>
                          Loading more channels...
                        </small>
                      )}
                    </div>
                  )}
                  <>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px",
                        marginBottom: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "100%", textAlign: "left" }}>
                        <label style={{ textAlign: "left", marginTop: "10px", color: "black" }}>Schedule</label>
                        <select
                          value={scheduleFrequency}
                          onChange={(e) => handleScheduleFrequencyChange(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "10px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            fontSize: "14px",
                          }}
                        >
                          <option value="none">No repeat</option>
                          <option value="daily">Daily</option>
                          <option value="weekly">Weekly</option>
                          <option value="weekdays">Week Days Only</option>
                          <option value="weekends">Weekends Only</option>
                          <option value="monthly">Monthly</option>
                          <option value="yearly">Yearly</option>
                        </select>
                      </div>

                      {/* Conditional fields based on frequency */}
                      {scheduleFrequency === "daily" && (
                        <div style={{ width: "100%", textAlign: "left" }}>
                          <label style={{ textAlign: "left", marginTop: "10px", color: "black" }}>Time</label>
                          <input
                            type="time"
                            value={scheduleTime}
                            onChange={(e) => handleScheduleTimeChange(e.target.value)}
                            style={{
                              width: "100%",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      )}
                      {scheduleFrequency === "weekly" && (
                        <>
                          <div style={{ width: "100%", textAlign: "left" }}>
                            <label style={{ textAlign: "left", marginTop: "10px", color: "black" }}>Select Day of Week</label>
                            <select
                              value={selectedWeekDays[0] || ''}
                              onChange={e => setSelectedWeekDays([e.target.value])}
                              style={{
                                padding: "8px !important",
                                width: "100%",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                fontSize: "14px",
                              }}
                            >
                              <option style={{ padding: "8px !important" }} value="" disabled>Select a day</option>
                              {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                                <option style={{ padding: "8px !important" }} key={day} value={day}>{day}</option>
                              ))}
                            </select>
                          </div>
                          <div style={{ width: "100%", textAlign: "left" }}>
                            <label style={{ marginTop: "10px", color: "black" }}>Time</label>
                            <input
                              type="time"
                              value={scheduleTime}
                              onChange={(e) => handleScheduleTimeChange(e.target.value)}
                              style={{
                                width: "100%",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                fontSize: "14px",
                              }}
                            />
                          </div>
                        </>
                      )}
                      {(scheduleFrequency === "weekdays" || scheduleFrequency === "weekends") && (
                        <div style={{ width: "100%", textAlign: "left" }}>
                          <label style={{ marginTop: "10px", color: "black" }}>Time</label>
                          <input
                            type="time"
                            value={scheduleTime}
                            onChange={(e) => handleScheduleTimeChange(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "8px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      )}

                      {(scheduleFrequency === "monthly" || scheduleFrequency === "yearly") && (
                        <>
                          <div style={{ width: "100%", textAlign: "left" }}>
                            <label style={{ textAlign: "left", marginTop: "10px", color: "black" }}>Select Date</label>
                            <input
                              type="date"
                              value={scheduleDate || ''}
                              onChange={e => setScheduleDate(e.target.value)}
                              style={{
                                width: "100%",
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                fontSize: "14px",
                              }}
                            />
                          </div>
                          <div style={{ width: "100%", textAlign: "left" }}>
                            <label style={{ textAlign: "left", marginTop: "10px", color: "black" }}>Time</label>
                            <input
                              type="time"
                              value={scheduleTime}
                              onChange={(e) => handleScheduleTimeChange(e.target.value)}
                              style={{
                                width: "100%",
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                fontSize: "14px",
                              }}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </>


                  <div className="formGroup" style={{ marginBottom: "20px" }}>
                    <label>Prompt Content</label>
                    <textarea
                      className="flex-1 modalInputs"
                      style={{ width: "100%", minHeight: "150px" }}
                      value={promptContent}
                      onChange={(e) => {
                        setPromptContent(e.target.value);
                        setPromptContentError(null);
                      }}
                    ></textarea>
                    {promptContentError && (
                      <small style={{ color: "red" }}>{promptContentError}</small>
                    )}
                  </div>

                  <div className="formGroup">
                    <label>Set as</label>
                    <div className="radio-group">
                      <div className="radio-button left">
                        <input
                          type="radio"
                          id="personal"
                          className="radio-input"
                          name="radio-group"
                          value="personal"
                          checked={promptSetAs === "personal"}
                          onChange={(e) => setPromptSetAs(e.target.value)}
                        />
                        <label htmlFor="personal" className="radio-label-new">
                          Personal
                        </label>
                      </div>
                      <div className="radio-button right">
                        <input
                          type="radio"
                          id="shared"
                          className="radio-input"
                          name="radio-group"
                          value="shared"
                          checked={promptSetAs === "shared"}
                          onChange={(e) => setPromptSetAs(e.target.value)}
                        />
                        <label htmlFor="shared" className="radio-label-new">
                          <span style={{ marginRight: "8px" }}>
                            <Icon id="shared" />
                          </span>
                          Shared
                        </label>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "10px", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <p
                      className="disagreeBtn"
                      style={{
                        margin: 0,
                        width: "100%",
                        opacity: processing ? 0.6 : 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      disabled={processing}
                      onClick={handlePromptSubmit}
                    >
                      {processing && <div className="spinner"></div>}
                      {isEdit ? "Done" : "Save"}
                    </p>
                    {isEdit && (
                      <p
                        style={{
                          margin: 0,
                          width: "30%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#C00F0C",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={() => setAskToDeleteModal(true)}
                      >
                        Delete this Task
                      </p>
                    )}
                  </div>
                </>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </Modal>

      <DeleteChatModal
        modelType="Task"
        isModalOpen={askToDeleteModal}
        contact={editadata}
        yesDelete={editadata?.scheduleTime ? handleDeleteScheduledPrompt : handleDeleteClick}
        justCloseIt={() => setAskToDeleteModal(false)}
        type="prompt"
      />

      {openIntegrationModal && <IntegrationModal
        isOpen={openIntegrationModal}
        onClose={() => {
          setOpenIntegrationModal(false);
          setLoadingIntegrations(false);
        }}
        rqIntegration={rqIntegration}
        requiredIntegrations={requiredIntegrations}
        integration_id={integrationId}
        onAllConnected={() => {
          fetchProviders(rqIntegration);
        }}
      />}
    </div>
  );
};

const AddCategoryModal = ({ onClose }) => {
  const { SSO } = useUsersContext();

  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState();
  const [categoryName, setCategoryName] = useState();

  const handleCategorySubmit = async () => {
    setProcessing(true);
    setError(false);

    if (categoryName === "" || categoryName === undefined) {
      setError(true);
      setProcessing(false);
      return false;
    }

    const response = await axios.post(`${BASE_URL}/prompts/category`, {
      name: categoryName,
      userId: SSO?.UserInfo?.userId,
      locationId: SSO?.id,
      type: "user",
    });

    setProcessing(false);
    if (response) {
      onClose();
    }
  };
  return (
    <div style={{ position: "relative" }}>
      <p
        style={{
          position: "absolute",
          right: 0,
          width: "12px",
          height: "12px",
          cursor: "pointer",
        }}
        onClick={onClose}
      >
        <Icon id="close" />
      </p>
      <p className="modalText">Add Category</p>
      <div className="formGroup" style={{ marginBottom: "20px" }}>
        <label>Name</label>
        <input
          type="text"
          name="name"
          placeholder="Category Name"
          className="flex-1 modalInputs"
          onChange={(e) => setCategoryName(e.target.value)}
        />
        {error && (
          <small style={{ color: "red" }}>Category name required!</small>
        )}
      </div>
      <button
        className="disagreeBtn"
        style={{
          margin: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: processing ? 0.6 : 1,
        }}
        disabled={processing}
        onClick={handleCategorySubmit}
      >
        {processing && <div className="spinner"></div>}
        Save
      </button>
    </div>
  );
};

const AddSubCategoryModal = ({ onClose, categories }) => {
  const { SSO } = useUsersContext();

  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState();
  const [subCategoryName, setSubCategoryName] = useState();
  const [category_id, setcategory_id] = useState();

  const handleCategorySubmit = async () => {
    setProcessing(true);
    setError(false);

    if (subCategoryName === "" || subCategoryName === undefined) {
      setError(true);
      setProcessing(false);
      return false;
    }

    const response = await axios.post(`${BASE_URL}/prompts/subcategory`, {
      name: subCategoryName,
      category_id: category_id,
      userId: SSO?.UserInfo?.userId,
      locationId: SSO?.id,
      type: "user",
    });

    setProcessing(false);
    if (response) {
      onClose();
    }
  };
  return (
    <div style={{ position: "relative" }}>
      <p
        style={{
          position: "absolute",
          right: 0,
          width: "12px",
          height: "12px",
          cursor: "pointer",
        }}
        onClick={onClose}
      >
        <Icon id="close" />
      </p>
      <p className="modalText">Add Sub Category</p>
      <div className="formGroup" style={{ marginBottom: "20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <label>Select Parent Category</label>
        </div>
        <select
          className="flex-1 modalInputs"
          style={{ width: "100%" }}
          name="promptCategory"
          value={category_id}
          onChange={(e) => {
            setcategory_id(e.target.value);
          }}
        >
          <option selected disabled>
            Select Category
          </option>
          {categories?.map((item, index) => (
            <option value={item._id}>{item.name}</option>
          ))}
        </select>
      </div>
      <div className="formGroup" style={{ marginBottom: "20px" }}>
        <label>Name</label>
        <input
          type="text"
          name="name"
          placeholder="Sub Category Name"
          className="flex-1 modalInputs"
          onChange={(e) => setSubCategoryName(e.target.value)}
        />
        {error && (
          <small style={{ color: "red" }}>Sub Category name required!</small>
        )}
      </div>
      <button
        className="disagreeBtn"
        style={{
          margin: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: processing ? 0.6 : 1,
        }}
        disabled={processing}
        onClick={handleCategorySubmit}
      >
        {processing && <div className="spinner"></div>}
        Save
      </button>


    </div>
  );
};

export default PromptModal;
